



















































import { Component, Vue } from 'vue-property-decorator'
import PageHeader from '@/components/PageHeaderComponent.vue'
import PhoneConfirmationService from '@/api/phone/PhoneConfirmationService'
import LogService from '@/api/broadcast/LogService'
import store from '@/store/store'
import UserManagementService from '@/api/user/UserManagementService'
import { BookingSignalPhone } from '@/shared/models/BookingSignalPhone'
import AuthenticationService from '@/api/security/AuthenticationService'
import BookingSignalService from '@/api/hotel/BookingSignalService'
import User from '@/api/user/models/User'
import PopUpComponent from '@/components/popups/PopUpComponent.vue'
import ButtonGroupComponent from '@/components/buttons/ButtonGroupComponent.vue'
import InputFieldNumberComponent from '@/components/input/InputFieldNumberComponent.vue'

@Component({
  components: {
    PageHeader,
    PopUpComponent,
    ButtonGroupComponent,
    InputFieldNumberComponent
  }
})
export default class V2ConfirmPhonePage extends Vue {
    public confirmationCode = '';
    public isLoading = false;
    public isError = false;
    private allowedForResend = false;
    private bookingSignalPhone: BookingSignalPhone = new BookingSignalPhone();
    public closeIcon = false;
    public showExistingUserPopUp = false;
    public showErrorPopUp = false;
    public resendCallClicked = false;
    public resendSMSClicked = false;

    public async created () {
      if ((!this.$store.state.vaerifyUser.PhoneNumber) && !this.$route.params.soMeType) {
        this.$router.push({ name: 'sign-up' })
      }

      await this.Login()
      await this.SendConfirmationCode()

      if (this.$store.state.vaerifyUser.PMSBookingNumber) {
        this.bookingSignalPhone = {
          HotelId: this.$store.state.vaerifyUser.HotelId,
          PMSBookingNumber: this.$store.state.vaerifyUser.PMSBookingNumber,
          ReservationNumber: this.$store.state.vaerifyUser.ReservationNumber,
          PhoneNumber: this.$store.state.vaerifyUser.PhoneNumber
        }
      }
    }

    private async Login () {
      for (let index = 0; index < 20; index++) {
        try {
          const response = await AuthenticationService.VaerifyUserLogin(this.$store.state.vaerifyUser.PhoneNumber, this.$store.state.vaerifyUser.Id)
          store.saveToken(response.Sessions[0].Token)
          return
        } catch (error) {
          await this.sleep(1000)
        }
      }
    }

    private sleep (milliseconds: number) {
      return new Promise((resolve) => setTimeout(resolve, milliseconds))
    }

    private async CreateUser () {
      try {
        const response = await UserManagementService.CreateUser(this.$store.state.vaerifyUser)
      } catch (error) {
        LogService.LogError('Join, ConfirmPhonePage, Failed to create user', { })
      }
    }

    private async SendConfirmationCode () {
      try {
        // await PhoneConfirmationService.V2SendConfirmationCode(this.$store.state.vaerifyUser.PhoneNumber.substring(1))
        await PhoneConfirmationService.V5SendConfirmationCode(this.$store.state.vaerifyUser.PhoneNumber.substring(1), 'sms')
        this.allowedForResend = true
      } catch (error) {
        this.allowedForResend = true
        if (error.response.status === 409) {
          this.showExistingUserPopUp = true
          this.$router.push({ name: 'downloadapppage', params: { accExists: 'true' } })
        } else {
          this.showErrorPopUp = true
        }
      }
    }

    public async ConfirmVerificationCode () {
      if (this.confirmationCode !== '') {
        this.isLoading = true
        try {
          await PhoneConfirmationService.ConfirmMobilePhone(this.$store.state.vaerifyUser.PhoneNumber, this.confirmationCode)
          if (this.$store.state.vaerifyUser.PMSBookingNumber) {
            await this.UpdateBookingSignalPhoneNumber(this.bookingSignalPhone)
          }
          if (this.$route.params.soMeType) {
            this.CreateSoMeUser(this.$route.params.soMeType)
          } else {
            this.CreateUser()
          }
          this.$router.push({ name: 'downloadapppage' })
          LogService.LogInformation('Join, ConfirmPhonePage, Confirmed verification code', { ConfirmedVerificationCode: 1 })
        } catch (error) {
          LogService.LogError(`Join, ConfirmPhonePage, Could not confirm verification code, with error: ${error}`, { VerificationCodeFailed: 1 })
          this.HandleException()
        }
      }
    }

    private async CreateSoMeUser (type: string) {
      const userInfo = new User()
      const webCheckIn = await store.getHotelInfo()
      userInfo.PhoneNumber = this.$store.state.vaerifyUser.PhoneNumber
      userInfo.CreationType = webCheckIn?.EntryType ?? 'Raw'
      userInfo.Id = webCheckIn?.UserId ?? null

      switch (type) {
        case 'apple':
          userInfo.AppleId = this.$store.state.appleUser.Id
          userInfo.Email = this.$store.state.appleUser.Email
          userInfo.FirstName = this.$store.state.appleUser.FirstName
          userInfo.LastName = this.$store.state.appleUser.LastName
          break
        default:
          break
      }
      try {
        await UserManagementService.CreateUserWithoutPassword(userInfo)
      } catch (e) {
        LogService.LogError(`Could not create user without password with info: ${JSON.stringify(userInfo)}`, {})
      }
    }

    // public async ResendVerificationCode () {
    //   try {
    //     if (this.allowedForResend) {
    //       this.isLoading = true
    //       const validPhone = await PhoneConfirmationService.GetPhoneConfirmation(this.$store.state.vaerifyUser.PhoneNumber.substring(1))
    //       const response = await PhoneConfirmationService.SendConfirmationCode(this.$store.state.vaerifyUser.PhoneNumber.substring(1))
    //       this.isLoading = false
    //       // this.$toasted.global.toast_success({ message: this.$t('confirmPhone.codeResent') })
    //       this.$store.dispatch('toastSuccess', { title: this.$t('confirmPhone.codeResent') })
    //       LogService.LogInformation('Join, ConfirmPhonePage, Verification code sent again', { VerificationCodeResend: 1 })
    //     }
    //   } catch (error) {
    //     LogService.LogError('Join, ConfirmPhonePage, Could not resend verification code', { VerificationCodeResendFailed: 1 })
    //     this.HandleExeption()
    //   }
    // }

    public async ResendVerificationCode (confirmationChannel: string) {
      try {
        if (this.allowedForResend) {
          this.isLoading = true
          const validPhone = await PhoneConfirmationService.GetPhoneConfirmation(this.$store.state.vaerifyUser.PhoneNumber.substring(1))
          const response = await PhoneConfirmationService.V5SendConfirmationCode(this.$store.state.vaerifyUser.PhoneNumber.substring(1), confirmationChannel)
          this.isLoading = false
          if (confirmationChannel === 'sms') {
            this.resendSMSClicked = true
          } else {
            this.resendCallClicked = true
          }
          this.$store.dispatch('toastSuccess', { title: confirmationChannel === 'sms' ? this.$t('confirmPhone.codeResent') : this.$t('confirmPhone.receiveCallInSeconds') })
          LogService.LogInformation('Join, ConfirmPhonePage, Verification code sent again', { VerificationCodeResend: 1 })
        }
      } catch (error) {
        LogService.LogError(`Join, ConfirmPhonePage, Could not resend verification code, error: ${error}`, { VerificationCodeResendFailed: 1 })
        this.HandleException()
      }
    }

    public setConfirmationCode (code: string) {
      this.confirmationCode = code
    }

    private async HandleException () {
      this.isLoading = false
      this.isError = true
    }

    private async UpdateBookingSignalPhoneNumber (request: BookingSignalPhone) {
      try {
        await BookingSignalService.UpdatePhoneHash(request)
      } catch (error) {
        LogService.LogInformation(`Failed to update phone hash for bookingId with error: ${JSON.stringify(error)} (Join)`, {})
      }
    }
}
